var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sso-callback-wrapper"},[_c('p',[_vm._v(_vm._s(_vm.$t('ssoCallback.loading')))])])}
var staticRenderFns = []

export { render, staticRenderFns }